// ResetPassword.jsx
import React, { useState } from "react";
import Classes from "../Settings.module.css";
import { useSelector } from "react-redux";
import backend from "../../../../../api";

export default function ResetPassword() {
  const { user } = useSelector((s) => s.auth);
  const userId = user?._id;
  const email = user?.email;

  const [form, setForm] = useState({
    currentPassword: "",
    confirmCurrentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId || !email) return alert("Missing user session.");

    // basic validations
    if (form.currentPassword !== form.confirmCurrentPassword) {
      return alert("Current password confirmation does not match.");
    }
    if (form.newPassword !== form.confirmNewPassword) {
      return alert("New password confirmation does not match.");
    }
    if (form.newPassword.length < 6) {
      return alert("New password must be at least 6 characters.");
    }

    setLoading(true);
    try {
      // 1) Verify current password using login route
      await backend.post("/api/user/login", {
        email,
        password: form.currentPassword,
      });

      // 2) Change password
      await backend.put(`/api/user/changepassword/${userId}`, {
        password: form.newPassword,
      });

      alert("Password updated successfully.");
      setForm({
        currentPassword: "",
        confirmCurrentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      });
    } catch (err) {
      console.error("Password change error:", err?.response?.data || err.message);
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Failed to update password.";
      alert(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className={Classes.form} onSubmit={handleSubmit}>
      <div className={Classes.flexColGroup}>
        <div className={Classes.flexCol1}>
          <h5 className={Classes.label}>Current Password</h5>
          <input
            type="password"
            className={Classes.inputField}
            name="currentPassword"
            value={form.currentPassword}
            onChange={onChange}
            required
          />
        </div>
        <div className={Classes.flexCol1}>
          <h5 className={Classes.label}>Confirm Current Password</h5>
          <input
            type="password"
            className={Classes.inputField}
            name="confirmCurrentPassword"
            value={form.confirmCurrentPassword}
            onChange={onChange}
            required
          />
        </div>
      </div>

      <div className={Classes.flexColGroup}>
        <div className={Classes.flexCol1}>
          <h5 className={Classes.label}>New Password</h5>
          <input
            type="password"
            className={Classes.inputField}
            name="newPassword"
            value={form.newPassword}
            onChange={onChange}
            required
          />
        </div>
        <div className={Classes.flexCol1}>
          <h5 className={Classes.label}>Confirm New Password</h5>
          <input
            type="password"
            className={Classes.inputField}
            name="confirmNewPassword"
            value={form.confirmNewPassword}
            onChange={onChange}
            required
          />
        </div>
      </div>

      <div className={Classes.actions}>
        <button type="submit" className={Classes.saveBtn} disabled={loading}>
          <h5>{loading ? "Updating..." : "Reset Password"}</h5>
        </button>
      </div>
    </form>
  );
}
